import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/business-valuation',
  component: () => import('../../routes/BusinessValuation.svelte'),
  card: {
    id: 'business-valuation',
    title: 'Business Valuation',
    description: 'Value a business using Discounted Cash Flow (DCF) analysis',
    icon: 'business',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/business-valuation',
    category: 'Business',
  },
  seo: {
    title: 'Business Valuation Calculator – DCF & Earnings Multiple Valuation',
    description: 'Free business valuation calculator using Discounted Cash Flow (DCF) analysis. Estimate the fair value of any business by projecting future cash flows and discounting them to present value.',
  },
};

export default meta;
